import { css } from '@/styled-system/css';

// Figma widths with no matching size token.
const CONTENT_MAX_WIDTH = '720px';
const CONTENT_WITH_TIP_MAX_WIDTH = '728px';
const TIP_CARD_WIDTH = '328px';
const FOOTER_BUTTON_MIN_WIDTH = '164px';

// Panda extracts responsive values only when they are written inline, so the device margins repeat.
export const wizardContainerStyles = css.raw({
  width: '100%',
  maxWidth: 'breakpoint-xxl',
  marginInline: 'auto',
  paddingInline: { base: 'device.margin.mobile', md: 'device.margin.tablet', xl: 'device.margin.desktop' },
});

// Modal.Header sets paddingInline longhands, which a paddingInline shorthand loses to.
export const wizardHeaderStyles = css.raw({
  width: '100%',
  maxWidth: 'breakpoint-xxl',
  marginInline: 'auto',
  paddingInlineStart: { base: 'device.margin.mobile', md: 'device.margin.tablet', xl: 'device.margin.desktop' },
  paddingInlineEnd: { base: 'device.margin.mobile', md: 'device.margin.tablet', xl: 'device.margin.desktop' },
  paddingBlock: { base: 'layout.tight', md: 'layout.default' },
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: 'layout.tight',
});

export const wizardExitButtonStyles = css.raw({ whiteSpace: 'nowrap', flexShrink: 0 });

export const wizardBodyStyles = css.raw({ paddingInline: 'none', paddingBlock: 'layout.default' });

export const wizardStepGridStyles = css.raw({
  display: 'grid',
  gridTemplateColumns: { base: 'minmax(0, 1fr)', xl: `minmax(0, ${CONTENT_MAX_WIDTH})` },
  columnGap: 'layout.vast.looser',
  rowGap: { base: 'layout.loose', md: 'layout.looser' },
  alignItems: 'start',
});

// Kept apart so that Panda extracts this value where it is defined; the body merges it at run time.
export const wizardStepGridWithTipStyles = css.raw({
  gridTemplateColumns: {
    base: 'minmax(0, 1fr)',
    xl: `minmax(0, ${CONTENT_WITH_TIP_MAX_WIDTH}) ${TIP_CARD_WIDTH}`,
  },
});

export const wizardFooterStyles = css.raw({
  paddingInline: 'none',
  paddingBlock: { base: 'layout.tight', md: 'layout.default' },
});

export const wizardFooterButtonStyles = css.raw({ minWidth: { lg: FOOTER_BUTTON_MIN_WIDTH } });

// Kept apart so that Panda extracts both values; the footer merges one of them at run time.
export const wizardFooterSpaceBetweenStyles = css.raw({ justifyContent: 'space-between' });

export const wizardFooterEndStyles = css.raw({ justifyContent: 'flex-end' });
